import React, { useCallback, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { MyPolicy } from '../../auth/core/_models'
import { ClaimIntimationForm } from './ClaimIntimationForm'
import { SubmittedIntimationList } from './SubmittedIntimationList'
import { useAuth } from '../../auth/core/Auth'

type Props = {
    show: boolean
    handleClose: () => void
    policy: MyPolicy
}

export const ClaimHubModel: React.FC<Props> = ({ show, handleClose, policy }) => {
    const [showClaimIntimation, setShowClaimIntimation] = useState(false)
    const [memberList, setMemberList] = useState<{ id: string; name: string; relation: string }[]>([]);
    const [submittedIntimations, setSubmittedIntimations] = useState<any[]>([]);
    const [memberLoading, setMemberLoading] = useState(false);
    const [claimsLoading, setClaimsLoading] = useState(false);
    const { currentUser } = useAuth()

    const fetchMemberList = useCallback(async () => {
        setMemberLoading(true);
        try {
            const response = await fetch('https://etl.futurisk.in/webhook/ClaimIntimationFetchEmployee', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    policyId: policy.Policy.PolicyId,
                    EmployeeNumber: currentUser?.EmployeeId,
                    Email: currentUser?.Email,
                }),
            })
            const data = await response.json()
            console.log('ClaimIntimationFetchEmployee response:', data)
            const memberArray = Array.isArray(data) ? data : data?.MemberList || []
            const members = memberArray.map((member: any) => ({
                id: String(member.sid),
                name: member.Name,
                relation: member.Relation,
            }));
            setMemberList(members);
        } catch (error) {
            console.error('Error fetching member list:', error)
        } finally {
            setMemberLoading(false);
        }
    }, [policy.Policy.PolicyId, currentUser?.EmployeeId, currentUser?.Email])

    const fetchSubmittedClaims = useCallback(async () => {
        setClaimsLoading(true);
        try {
            const response = await fetch('https://etl.futurisk.in/webhook/8253c598-d003-4753-9383-715f63d6e0ff', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    policyId: policy.Policy.PolicyId,
                    EmployeeNumber: currentUser?.EmployeeId,
                    Email: currentUser?.Email,
                }),
            })
            const data = await response.json()
            console.log('Submitted claims response:', data)
            const claimsArray = Array.isArray(data) ? data : data?.Claims || data?.claims || []
            setSubmittedIntimations(claimsArray);
        } catch (error) {
            console.error('Error fetching submitted claims:', error)
        } finally {
            setClaimsLoading(false);
        }
    }, [policy.Policy.PolicyId, currentUser?.EmployeeId, currentUser?.Email])

    useEffect(() => {
        if (show) {
            initMap()
            fetchMemberList()
            fetchSubmittedClaims()
        }
    }, [show, fetchMemberList, fetchSubmittedClaims])

    const dissmissLocation = () => {
        handleClose()
    }

    const initMap = () => { }

    return (
        <Modal
            className='modal fade'
            id='kt_modal_test'
            data-backdrop='static'
            tabIndex={-1}
            role='model'
            show={show}
            dialogClassName=' modal-xl'
            aria-hidden='true'
            onHide={dissmissLocation}
        >
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title'>Claims</h5>
                    <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        onClick={dissmissLocation}
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
                    </div>
                </div>
                <div className='modal-body'>
                    {memberLoading || claimsLoading ? (
                        <div className="text-center">
                            <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                        </div>
                    ) : (
                        <>
                            <button
                                className='btn btn-primary mb-4'
                                onClick={() => setShowClaimIntimation(!showClaimIntimation)}
                            >
                                {showClaimIntimation ? 'Back to Claims' : 'Claim Intimation'}
                            </button>
                            {showClaimIntimation ? (
                                <ClaimIntimationForm
                                    memberList={memberList}
                                    policyId={policy.Policy.PolicyId}
                                    employeeId={currentUser?.EmployeeId}
                                    email={currentUser?.Email}
                                    onSubmitSuccess={() => {
                                        fetchMemberList()
                                        fetchSubmittedClaims()
                                        setShowClaimIntimation(false)
                                    }}
                                />
                            ) : (
                                <SubmittedIntimationList
                                    items={submittedIntimations}
                                    memberList={memberList}
                                    employeeId={currentUser?.EmployeeId}
                                    onDocumentSaveSuccess={() => {
                                        fetchMemberList()
                                        fetchSubmittedClaims()
                                    }}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </Modal>
    )
}

